// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"c741f877","623":"eb8e3e00"}[chunkId] + ".chunk.css";
};